export default __webpack_public_path__ + "static/media/mar2024-2.e1989f6c.jpg";